// extracted by mini-css-extract-plugin
export default {"container":"AddPackage_container__ihRY-","heading":"AddPackage_heading__oN5xQ","form":"AddPackage_form__x+ywq","buttonContainer":"AddPackage_buttonContainer__v59qX"};